export const content = {
  titel: 'Vorschläge prüfen',
  buttons: {
    verwerfenUndUmplanen: 'Alle Vorschläge der Leistung verwerfen & umplanen',
    auswahlAufheben: 'Auswahl aufheben',
    uebernehmen: 'Vorschlag übernehmen',
    schliessen: 'Schließen',
  },
} as const;
